/* unplugin-vue-components disabled */import script from "./school-only.vue?vue&type=script&setup=true&lang=js"
export * from "./school-only.vue?vue&type=script&setup=true&lang=js"

import "./school-only.vue?vue&type=style&index=0&id=5800cf82&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5800cf82"]])

export default __exports__